import { Navigation, Swiper } from 'swiper';
import { addZero, isMobile, isTablet, isVerticalTablet } from '@/modules/functions';

export class CardWorkBenefits {
  slider;
  constructor() {}

  init() {
    this.slider = document.querySelector('.card-work-benefits-slider');
    if (!this.slider) return;

    this.current = document.querySelector('.card-work-benefits-count-current');
    this.total = document.querySelector('.card-work-benefits-count-total');

    Swiper.use([Navigation]);

    this.createSlider();
  }

  createSlider() {
    const items = this.slider.querySelectorAll('.card-work-benefits-item');

    const length = items.length;

    let slidesPerView = 4;

    if(isTablet()) {
      slidesPerView = 3;
    }

    if(isVerticalTablet()) {
      slidesPerView = 2;
    }

    if(isMobile()) {
      slidesPerView = 1;
    }

    this.total.innerText = addZero(
      length - slidesPerView + 1
    );
    this.current.innerText = addZero(1);

    if(length <= slidesPerView) {
      this.current.parentElement.classList.add('hide');
    }

    console.log(slidesPerView);

    this.slider = new Swiper('.card-work-benefits-slider', {
      navigation: {
        prevEl: '.card-work-benefits-slider-prev',
        nextEl: '.card-work-benefits-slider-next',
      },
      on: {
        slideChange: (swiper) => {
          this.current.innerText = addZero(swiper.activeIndex + 1);
        },
      },
      breakpoints: {
        0: {
          slidesPerView
        },
        768: {
          slidesPerView
        },
        992: {
          slidesPerView
        },
        1200: {
          slidesPerView
        }
      }
    });
  }
}
